
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'marketplace-storefront-public-ui',
  currentProjectVersion: 'static-1.13293',
  depVersions: {
  "marketplace-storefront-public-ui": "static-1.13293",
  "apollo-dlb": "static-3.98",
  "breeze-builder-lib": "static-1.852",
  "client-types": "static-1.501",
  "data-fetching-client": "static-1.9989",
  "foundations-components": "static-1.8538",
  "foundations-components-legacy": "static-1.1563",
  "foundations-theming": "static-1.4812",
  "googlemaps-react-wrapper": "static-1.3",
  "graphql": "static-1.89",
  "head-dlb": "static-1.5007",
  "hs-test-utils": "static-1.8369",
  "hub-http-shared-msw-handlers": "static-1.10670",
  "hubspot-dlb": "static-2.1905",
  "hubspot-url-utils": "static-1.4366",
  "HubStyleTokens": "static-2.11827",
  "I18n": "static-7.1679",
  "jasmine-runner": "static-1.6786",
  "marketplace-discovery-studio-lib": "static-1.686",
  "marketplace-storefront-base": "static-1.13356",
  "quartz": "static-1.7502",
  "react-dlb": "static-1.89",
  "react-rhumb": "static-1.17059",
  "reactive-variable-buffer-atom": "static-1.3190",
  "reporting-testing-lib": "static-1.10840",
  "reselect": "static-3.12",
  "settings-ui-lib": "static-1.12860",
  "SharedI18nStrings": "static-1.183",
  "signup-ui-core": "static-1.10391",
  "source-map": "static-1.4",
  "trellis-ecosystem": "static-1.7669",
  "ui-addon-i18n": "static-1.11482",
  "ui-addon-react-router-dom": "static-1.9868",
  "unified-auth": "static-1.973",
  "unified-auth-core-lib": "static-1.1255",
  "usage-tracker": "static-1.7649",
  "usage-tracker-core": "static-1.7499",
  "customer-data-property-utils": "static-1.8434",
  "hub-http": "static-1.6548",
  "integrations-lib": "static-1.17118",
  "marketplace-ui-common": "static-1.20793",
  "marketplace-ui-install": "static-1.779",
  "property-management-iframe": "static-1.14190",
  "quartz-config": "static-1.1280",
  "quartz-core": "static-1.6721",
  "quartz-routing": "static-1.932",
  "quick-fetch": "static-1.4151",
  "react": "static-7.196",
  "rpc-client-utils": "static-1.5002",
  "ts-schema": "static-1.4317",
  "ui-universal-auth": "static-1.9459",
  "UIComponents": "static-3.8773",
  "apollo-stack-hubspot": "static-3.94",
  "enviro": "static-4.455",
  "hs-promise-rejection-tracking": "static-1.5587",
  "PortalIdParser": "static-2.404",
  "raven": "static-3.5925",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "immutable": "static-2.87",
  "metrics-js": "static-1.9963",
  "react-redux": "static-7.79",
  "redux": "static-4.80",
  "styled-components": "static-2.99",
  "moment": "static-3.75",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3779",
  "quartz-webpack": "static-1.3726",
  "bend-plugin-quartz-routing": "static-1.580",
  "ai-components-ui-library": "static-1.9782",
  "codemirror": "static-5.102",
  "foundations-assets": "static-1.5222",
  "pulse": "static-1.965",
  "react-codemirror": "static-1.10979",
  "ui-extensions-preview-lib": "static-1.667",
  "fast-json-stable-stringify": "static-1.4",
  "bend-plugin-foundations-components": "static-1.4807",
  "floating-ui": "static-1.63",
  "foundations-theming-specialty": "static-1.2528",
  "framer-motion": "static-1.79",
  "hs-story-utils": "static-1.9761",
  "react-aria": "static-1.72",
  "react-create-root-preference": "static-1.78",
  "react-select-plus": "static-1.113",
  "react-utils": "static-2.5579",
  "react-virtualized": "static-2.107",
  "StyleGuideUI": "static-3.507",
  "tanstack-table": "static-1.61",
  "trellis-assets": "static-1.2730",
  "ui-fonts": "static-1.1089",
  "ui-images": "static-2.1261",
  "bend-plugin-foundations-theming": "static-1.3295",
  "foundations-theming-base": "static-1.3797",
  "stylex": "static-1.41",
  "HeadJS": "static-2.803",
  "hs-test-utils-bend-plugin": "static-1.3480",
  "msw": "static-1.39",
  "testing-library": "static-1.158",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.230",
  "moment-timezone": "static-5.91",
  "jasmine": "static-4.4648",
  "ui-addon-video-player": "static-1.9038",
  "ai-rendering-library": "static-1.11154",
  "chirp-fetch": "static-1.2232",
  "connections-embed-lib": "static-1.1557",
  "copilot-toolkit": "static-1.11898",
  "feedback-loader": "static-1.29852",
  "laboratory-lib": "static-3.7489",
  "marketplace-embed": "static-1.22972",
  "marketplace-ui-details": "static-1.10688",
  "marketplace-ui-reviews": "static-1.20748",
  "marketplace-ui-tracking": "static-1.14963",
  "sanitize-text": "static-1.8493",
  "usage-tracker-multi": "static-1.6063",
  "usage-tracker-session-replay": "static-1.5335",
  "wootric-nps": "static-1.7224",
  "quartz-head": "static-1.1167",
  "web-vitals": "static-1.15",
  "apollo-link-hub-http": "static-2.4993",
  "immer": "static-1.101",
  "immerable": "static-1.4482",
  "highcharts": "static-8.111",
  "hs-lodash": "static-4.45",
  "reporting-client-types": "static-1.2714",
  "reporting-data": "static-1.68907",
  "cssUtils": "static-1.958",
  "flux-actions": "static-1.373",
  "react-colorpicker": "static-2.10549",
  "react-dnd-compat": "static-1.4952",
  "redux-observable": "static-1.75",
  "ReduxMessenger": "static-2.10706",
  "rxjs": "static-5.10",
  "underscore": "static-1.8",
  "usage-tracker-container": "static-1.7639",
  "icons": "static-2.693",
  "marketplace-ui-apps-core": "static-1.19325",
  "storybook-react": "static-1.40",
  "trellis-story-utils": "static-1.4843",
  "foundations-components-test-utils": "static-1.6021",
  "quartz-i18n": "static-1.1177",
  "react-input-autosize": "static-2.17",
  "adobe-sign-auth-lib": "static-1.522",
  "ads-unified-auth-lib": "static-1.1495",
  "custom-vendor-connection-lib": "static-1.23",
  "google-sheets-integration-lib": "static-1.1086",
  "microsoft-drive-auth-lib": "static-1.202",
  "surveymonkey-integration-lib": "static-1.541",
  "slack-ui-library": "static-1.10735",
  "fsm": "static-1.4088",
  "customer-data-objects": "static-1.8033",
  "property-translator": "static-1.5730",
  "hs-locale-management": "static-1.318",
  "frontend-preferences-client": "static-1.8254",
  "hs-promise-utils": "static-1.5926",
  "hubspot-apollo-client": "static-1.5213",
  "integrations-error-boundary-lib": "static-1.14533",
  "integrations-tracking-lib": "static-1.5944",
  "native-integrations-shared-strings": "static-1.8113",
  "sanitize": "static-1.4808",
  "superstore": "static-1.5095",
  "ui-shepherd-react": "static-3.10605",
  "ai-settings-ui-library": "static-1.8385",
  "hub-http-janus": "static-1.887",
  "hubspotter-http": "static-1.4887",
  "immutable-less": "static-1.4987",
  "marketplace-ui-client-types": "static-1.18200",
  "nav-meta": "static-1.30528",
  "react-window": "static-1.13",
  "ui-addon-upgrades": "static-9.18423",
  "ui-product-approvals-common": "static-1.1151",
  "ai-studio-lib": "static-1.12486",
  "hubspot-prosemirror": "static-1.19036",
  "integrations-reconnect-lib": "static-1.530",
  "ui-addon-iframeable": "static-1.9413",
  "ui-addon-integrations-directory-panel": "static-2.8363",
  "ui-product-approvals": "static-1.29256",
  "ui-tool-access": "static-1.10491",
  "inbound-db-properties-service-client": "static-1.4071",
  "property-management-common": "static-1.6478",
  "opentelemetry-fe-types": "static-1.112",
  "dispatcher": "static-1.143",
  "general-store": "static-6.20",
  "mobile-manifest-mixins": "static-1.583",
  "module-federation": "static-1.33",
  "opentelemetry-fe": "static-1.487",
  "quartz-auth": "static-1.1177",
  "quartz-test": "static-1.1177",
  "quartz-tracking": "static-1.881",
  "trellis-components": "static-1.2749",
  "csstype": "static-1.50",
  "bend-plugin-chirp-manifest": "static-1.412",
  "HubStyle": "static-2.12134",
  "bender-build-tools": "static-1.3452",
  "autolinker": "static-3.11",
  "chatspot-core": "static-1.23183",
  "ContentUtils": "static-1.69187",
  "customer-data-objects-ui-components": "static-1.13367",
  "sassPrefix": "static-1.225",
  "diff-match-patch": "static-1.7",
  "bend-plugin-pulse": "static-1.468",
  "batch-promise": "static-1.1881",
  "event-emitter": "static-1.1291",
  "fast-json-patch": "static-1.70",
  "browser-eslint": "static-2.57",
  "magpie-lib": "static-1.5782",
  "magpie-types": "static-1.5242",
  "stylex-utils": "static-1.147",
  "trellis-theming": "static-1.1309",
  "avatar-components": "static-1.2818",
  "breeze-engine-core": "static-1.1098",
  "breeze-onboarding-components": "static-1.793",
  "customer-data-filters-ui": "static-1.41008",
  "customer-data-reference-ui-components": "static-1.13515",
  "embedded-academy-lib": "static-1.15608",
  "ExportDialog": "static-6.10714",
  "global-styles-ai-lib": "static-1.199",
  "highlight.js": "static-1.86",
  "marketplace-embed-ba": "static-1.675",
  "markdown-it": "static-1.6",
  "mermaid": "static-1.3",
  "reporting-action-components": "static-1.42120",
  "reporting-snowflake": "static-1.57524",
  "reporting-ui-components": "static-2.66177",
  "reporting-visualizations": "static-1.60982",
  "trial-components-library": "static-1.14158",
  "ui-addon-teams": "static-1.21945",
  "upgrade-components-lib": "static-1.558",
  "navigation-components": "static-1.18891",
  "breeze-engine-lib": "static-1.1820",
  "simple-logging-lib": "static-1.3387",
  "fail-safe": "static-1.290",
  "app-governance-lib": "static-1.2444",
  "developer-experience-shared-components": "static-1.10874",
  "purchase-motions-components": "static-1.6407",
  "transmute": "static-2.97",
  "usage-based-billing-components-lib": "static-1.10356",
  "usage-tracker-anonymous": "static-1.6066",
  "usage-tracker-public": "static-1.7460",
  "amplitude-session-replay-browser": "static-1.60",
  "inbound-db-meta-service-client": "static-1.3718",
  "persist-promise": "static-1.4038",
  "reference-resolvers": "static-1.8517",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "ui-extensibility-client-types": "static-1.4253",
  "hubspot-apollo-cache": "static-1.672",
  "universal-page-editor-lib": "static-1.3344",
  "final-form": "static-1.78",
  "redux-toolkit": "static-1.78",
  "simple-data-table": "static-1.3571",
  "merchandise-lib": "static-1.279",
  "ui-addon-draggable": "static-3.5092",
  "content-assistance-lib": "static-1.8240",
  "content-media-capture": "static-1.5505",
  "customer-data-ui-utilities": "static-1.10167",
  "emoji-mart": "static-3.4",
  "file-manager-components": "static-1.24574",
  "growth-payments-core": "static-1.26245",
  "knowledge-content-types": "static-1.8681",
  "PatternValidationJS": "static-1.3228",
  "payment-link-components": "static-1.24211",
  "prosemirror": "static-1.13",
  "rich-text-lib": "static-1.20348",
  "ui-addon-emoji-picker": "static-1.10220",
  "ui-business-units-lib": "static-1.9427",
  "video-components-external": "static-1.12201",
  "video-data-lib": "static-1.35859",
  "navigation-messaging": "static-1.8218",
  "collaboration-sidebar": "static-1.58783",
  "crm-component-utils": "static-1.39900",
  "crm-properties-common-lib": "static-1.6226",
  "customer-data-properties": "static-1.52678",
  "external-options-client-types": "static-1.4364",
  "framework-data-schema-resolvers": "static-1.7229",
  "property-value-citations": "static-1.3292",
  "reference-resolvers-lite": "static-1.8440",
  "opentelemetry-web": "static-1.15",
  "beacon-keepalive-queue": "static-1.40",
  "hubspotter-http-shared-msw-handlers": "static-1.10668",
  "base-ui": "static-1.22",
  "react-day-picker": "static-1.10",
  "tanstack-virtual": "static-1.38",
  "cms-field-types": "static-1.5148",
  "content-icons-ui": "static-1.2399",
  "atom": "static-1.5418",
  "idb-keyval": "static-1.51",
  "reactive-lib": "static-1.1055",
  "breeze-artifacts-sdk": "static-1.444",
  "getting-started-shared-tasks": "static-1.19303",
  "onboarding-journeys-lib": "static-1.996",
  "onboarding-scopes": "static-1.6789",
  "conversations-skeleton-state": "static-1.7583",
  "crm-message-bus": "static-1.43826",
  "customer-data-filters-ui-msw-helpers": "static-1.23443",
  "events-data-lib": "static-1.584",
  "FormUrlGenerator": "static-2.5062",
  "framework-builder-read-service-client": "static-1.4245",
  "hs-resources": "static-1.528",
  "multi-account-reference-resolvers": "static-1.1343",
  "onboarding-tours": "static-1.17172",
  "react-immutable-proptypes": "static-2.8",
  "reporting-datasets-permissions-lib": "static-1.14520",
  "academy-common-lib": "static-1.15068",
  "dashboard-lib": "static-1.82934",
  "hubspot-prosemirror-plugins": "static-1.19028",
  "share-with-third-party-component-lib": "static-1.9044",
  "ui-asset-management-lib": "static-1.11434",
  "user-context": "static-1.5457",
  "reporting-plugins": "static-1.10796",
  "reporting-reports": "static-1.68584",
  "hubs-service-types": "static-1.1596",
  "purchase-motions-api": "static-1.6410",
  "salesImages": "static-1.596",
  "signup-constants": "static-1.19680",
  "nest": "static-1.573",
  "breeze-engine-chat-components": "static-1.798",
  "ably": "static-2.2",
  "bend-plugin-fail-safe": "static-1.241",
  "framework-listing-lib": "static-2.29557",
  "fuzzy": "static-1.8",
  "user-configuration-lib": "static-1.31501",
  "apps-service-types": "static-1.4067",
  "oauth-service-types": "static-1.4569",
  "signup-ui-url-generator": "static-2.8396",
  "onboarding-tours-client": "static-1.5387",
  "one-click-checkout": "static-1.473",
  "platform-infra-nav-components": "static-1.7917",
  "subscription-experience-data-types": "static-1.15271",
  "crm-record-cards-service-types": "static-1.3796",
  "location-customization-utils-lib": "static-1.10159",
  "redux-thunk": "static-2.80",
  "react-flip-move": "static-1.78",
  "ui-coaching-tips": "static-1.29364",
  "content-media-composition-data-lib": "static-1.13309",
  "fix-webm-duration": "static-1.30",
  "notification-sounds": "static-1.4761",
  "react-immutable-render-mixin": "static-1.9",
  "seat-types-lib": "static-1.795",
  "ui-addon-opt": "static-4.8702",
  "commerce-tours-lib": "static-1.6664",
  "growth-onboarding-reliability": "static-1.5416",
  "sales-checkout-service-client": "static-1.3864",
  "data-token-picker": "static-1.16928",
  "FileManagerLib": "static-1.40214",
  "content-media-compositions": "static-2.17316",
  "media-bridge-lib": "static-1.19447",
  "chatspot-widget-iframe": "static-1.23174",
  "collaboration-sidebar-common": "static-1.3580",
  "marketing-platform-lib": "static-1.7209",
  "card-properties-lib": "static-1.45071",
  "commerce-subscription-lib": "static-1.37843",
  "crm-actions": "static-1.6684",
  "crm-cards-sdk": "static-1.44659",
  "customer-data-properties-shared-msw-handlers": "static-1.9997",
  "customer-data-tracking": "static-1.7218",
  "calling-global-api": "static-1.65717",
  "calling-internal-common": "static-1.31658",
  "calling-lifecycle-internal": "static-1.67099",
  "calling-lifecycle-messages": "static-1.59393",
  "commerce-products-lib": "static-1.10603",
  "conditional-properties-service-client": "static-1.4040",
  "crm-index-visualization-core": "static-1.4583",
  "crm-links": "static-1.6658",
  "crm-pipelines-api-client-types": "static-1.4371",
  "formula-editor": "static-1.14812",
  "google-libphonenumber": "static-1.45",
  "inbounddb-objects-service-types": "static-1.4452",
  "meetings-icalendar-utils-lib": "static-1.971",
  "multi-currency-client-types": "static-1.3931",
  "object-builder-ui-client": "static-1.49750",
  "pipeline-validation-client-types": "static-1.4206",
  "smart-data-capture-core": "static-1.192",
  "smart-property-lib": "static-1.8360",
  "tiered-pricing": "static-1.2006",
  "topics-actions-lib": "static-1.504",
  "ui-addon-form-validation": "static-1.11320",
  "zustand": "static-1.85",
  "fdsr-migration-layer": "static-1.348",
  "framework-data-schema-quick-fetch": "static-1.7134",
  "restore-request-side-panel-lib": "static-1.1734",
  "growth-data-modal": "static-1.5935",
  "growth-onboarding-confetti": "static-1.3401",
  "growth-onboarding-next-action-utils": "static-1.2745",
  "onboarding-tours-utils": "static-1.1239",
  "ui-shepherd-tracker": "static-1.7986",
  "academy-service-client": "static-1.4028",
  "croppie": "static-2.10",
  "FileManagerCore": "static-1.40073",
  "SafeStorage": "static-1.4742",
  "video-embed": "static-1.36693",
  "redux-actions": "static-3.70",
  "EmailSignatureEditor": "static-1.25049",
  "viral-links-lib": "static-1.7412",
  "nested-table": "static-1.571",
  "timezone-utils": "static-2.5579",
  "getting-started-shared-tasks-store": "static-1.18421",
  "campaign-roi-lib": "static-1.10371",
  "campaigns-utils-lib": "static-1.3558",
  "ui-addon-calendars": "static-2.5677",
  "customer-data-views-management": "static-1.26082",
  "framework-data-table": "static-2.12604",
  "nudge-client-utils": "static-1.3190",
  "nudge-custom-ui-functions": "static-1.1536",
  "switchboard-lib": "static-1.556",
  "access-check-ui-lib": "static-1.1645",
  "app-users-service-client": "static-1.5956",
  "app-users-service-types": "static-1.5364",
  "mini-checkout-client": "static-1.27568",
  "onboarding-utils": "static-1.5707",
  "permissions-shared-i18n-strings-fe": "static-1.2123",
  "ui-coaching-tips-shared-config": "static-1.29349",
  "checkout-sdk": "static-3.24411",
  "payment-method-components": "static-1.7183",
  "touchless-buying-components": "static-1.6279",
  "upgrade-catalog-service-types": "static-1.3796",
  "edison-service-client-types": "static-1.730",
  "growth-onboarding-feedback-components": "static-1.6921",
  "audio-components": "static-1.6387",
  "FileManagerImages": "static-1.37725",
  "video-components": "static-1.14203",
  "js-cookie": "static-1.18",
  "crm_data": "static-4.92904",
  "customer-data-sidebar": "static-2.46789",
  "enrichment-lib": "static-1.515",
  "ui-addon-draggable-compat": "static-2.4599",
  "universal-record-utils-lib": "static-1.2052",
  "commerce-billing-lib": "static-1.20263",
  "commerce-shared-components-lib": "static-1.19294",
  "commerce-tools-ui-lib": "static-1.11100",
  "crm-fe-perf": "static-1.23234",
  "calling-error-reporting": "static-1.31665",
  "shared-worker-versioning": "static-1.11377",
  "calling-usage-tracker": "static-1.6872",
  "voice-sms-access-library": "static-1.2124",
  "commerce-permissions": "static-1.1113",
  "products-iframe-lib": "static-1.8640",
  "products-ui-components-shared-msw-handlers": "static-1.11052",
  "crm-index-associations-lib": "static-1.6780",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10753",
  "sales-views-client-types": "static-1.4592",
  "bark-lib": "static-1.16850",
  "browser-prettier": "static-1.11",
  "data-agent-kit": "static-1.694",
  "policy-lib": "static-1.7140",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.10816",
  "onboarding-data-sync-lib": "static-1.2558",
  "growth-onboarding-next-action-components": "static-1.2773",
  "user-context-client": "static-1.4844",
  "cropperjs": "static-1.10",
  "html-to-image": "static-1.61",
  "urlinator": "static-1.4866",
  "outpost": "static-1.4489",
  "draft-convert": "static-2.80",
  "draft-extend": "static-3.83",
  "draft-js": "static-5.85",
  "draft-plugins": "static-2.22200",
  "sales-email-signature-service-client": "static-1.4183",
  "ts-utils-lib": "static-1.484",
  "copilot-messaging": "static-1.2148",
  "crm-export-dialog": "static-1.6619",
  "crm-index-ui-shimmer": "static-1.2726",
  "crm-view-components": "static-1.1246",
  "react-beautiful-dnd": "static-1.70",
  "customer-data-associations": "static-1.7666",
  "tasks-actions-lib": "static-1.193",
  "nudge-custom-function-registry": "static-1.2947",
  "nudge-renderer-utils": "static-1.3266",
  "whisper-core-api": "static-1.7385",
  "InboxConnectUtils": "static-4.15611",
  "emoji-regex": "static-1.7",
  "settings-content-modals": "static-1.46901",
  "hub-http-rxjs": "static-1.854",
  "normalizr": "static-3.9",
  "ramda": "static-1.7",
  "billing-payments-client-types": "static-1.4328",
  "company-details-components": "static-1.6543",
  "react-performance-metrics-lib": "static-1.889",
  "pricing-pages-ui-components": "static-1.15955",
  "quote-checkout-service-types": "static-1.3788",
  "social-insights-client-types": "static-1.22706",
  "crm_universal": "static-1.22534",
  "customer-data-email": "static-1.18562",
  "card-payment-highlight-lib": "static-1.38051",
  "commerce-contract-lib": "static-1.13424",
  "invoices-highlight-card-lib": "static-1.55829",
  "orders-highlight-card-lib": "static-1.22248",
  "products-highlight-card-lib": "static-1.18886",
  "quotes-highlight-card-lib": "static-1.72850",
  "crm-source-interpretation-lib": "static-1.5667",
  "data-agent-utils": "static-1.577",
  "crm-object-search-query-utilities": "static-1.10243",
  "utility-belt": "static-1.2869",
  "payments-enrollment-embed-lib": "static-1.23899",
  "stripe-embedded-components": "static-1.8036",
  "customer-data-rte": "static-1.33695",
  "cv-backend-services": "static-1.1597",
  "growth-onboarding-empty-states": "static-1.6323",
  "payments-post-enroll-local-storage-lib": "static-1.5440",
  "qrcode-generator": "static-1.76",
  "quotes-client-types": "static-1.38940",
  "calling-orchestration-schema": "static-1.36901",
  "react-reducer-toolkit": "static-1.16419",
  "meetings-connect-utils-lib": "static-1.7947",
  "hub-http-contrib": "static-1.3376",
  "ui-addon-sales-email": "static-1.5550",
  "access-control-lib": "static-1.10773",
  "EmailComponents": "static-1.55605",
  "EmailData": "static-1.54283",
  "redux-less": "static-2.9811",
  "company-details-service-types": "static-1.4279",
  "segments-query-core": "static-1.1760",
  "pricing-pages-api": "static-1.15820",
  "sequences-lib": "static-1.8573",
  "ui-gdpr-components": "static-1.10632",
  "products-ui-components": "static-1.41121",
  "accounting-integrations-ui-components": "static-1.7579",
  "invoices-ui-lib": "static-1.55845",
  "commerce-products-api": "static-1.2727",
  "invoices-iframe-lib": "static-1.57903",
  "quotes-modal-lib": "static-1.103528",
  "quotes-ui-lib": "static-1.81571",
  "stripe-connect-js": "static-1.78",
  "draft-content-plugins": "static-1.28954",
  "ContentComponents": "static-2.72143",
  "ContentData": "static-1.69262",
  "marketing-email-service-types": "static-1.2115",
  "messaging-editing-lib": "static-1.47205",
  "messaging-usage-based-billing-components-lib": "static-1.2067",
  "automation-ui-source-apps": "static-1.19740",
  "automation-ui-types": "static-1.20658",
  "messaging-types-lib": "static-1.46942",
  "onboarding-settings-client": "static-1.4845",
  "sequences-client-types-lib": "static-1.8430",
  "commerce-tax-lib": "static-1.876",
  "price-books-api": "static-1.1784",
  "price-books-components": "static-1.1842",
  "property-description-translator": "static-1.4173",
  "ramp-editor": "static-1.940",
  "commerce-analytics-service-client": "static-1.3852",
  "totals-ui-components": "static-1.24343",
  "SalesContentIndexUI": "static-3.9660",
  "advanced-menus-core": "static-1.15620",
  "advanced-menus-lib": "static-1.12492",
  "automation-ui-ubb": "static-1.6574",
  "blueimp-md5": "static-1.8",
  "content-embed-lib": "static-1.7673",
  "data-token-views": "static-1.16909",
  "forms-utils-lib": "static-1.13133",
  "payments-embed-points-lib": "static-1.13636",
  "react-tinymce": "static-1.56034",
  "simple-menus-core": "static-1.15619",
  "simple-menus-lib": "static-1.17136",
  "tinymce": "static-5.11",
  "tinymce-config": "static-2.55160",
  "tinymce-data": "static-1.41245",
  "tinymce-plugins": "static-1.58274",
  "tinymce-themes": "static-1.57130",
  "ui-brand-identity-lib": "static-1.16603",
  "ui-memberships-settings-lib": "static-1.34898",
  "videoconference-integration-components": "static-1.7326",
  "automation-applications-service-types": "static-1.3658",
  "automation-platform-service-types": "static-1.2669",
  "ContentEditorUI": "static-2.77973",
  "content-whatsapp-service-types": "static-1.578",
  "short-messages-app-service-client": "static-1.4254",
  "web-interactives-components": "static-1.14290",
  "web-interactives-data": "static-1.14291",
  "messaging-shared-utils-lib": "static-1.1516",
  "messaging-user-info-utils-lib": "static-1.1686",
  "email-portal-health-service-types": "static-1.1318",
  "line-items-api": "static-1.1135",
  "commerce-totals-service-types": "static-1.4056",
  "FireAlarmUi": "static-1.4748",
  "sales-templates-service-types-lib": "static-1.4408",
  "seamless-immutable": "static-7.6",
  "automation-ui-core": "static-2.22594",
  "automation-ui-usage-tracking": "static-1.22057",
  "data-studio-ubb": "static-1.3564",
  "interframe": "static-3.5091",
  "layout-dnd-components": "static-1.13015",
  "layout-dnd-utils": "static-1.11990",
  "NamespacedHubStyle": "static-2.9289",
  "campaigns-lib": "static-1.27709",
  "content-management-data-lib": "static-1.6006",
  "copilot-plugins": "static-1.11870",
  "cta-picker": "static-1.37134",
  "customer-agent-discovery-components-lib": "static-1.4012",
  "editor-components": "static-1.13691",
  "editor-iframe-lib": "static-1.8839",
  "error-messaging-js": "static-1.5535",
  "FormsCommonComponents": "static-1.86635",
  "layout-data-lib": "static-1.10315",
  "pictos": "static-7.191",
  "react-transition-group": "static-2.73",
  "redux-request-state": "static-1.10983",
  "SharedLegalStrings": "static-1.2078",
  "smart-content-core": "static-1.43228",
  "smart-content-lib": "static-1.43881",
  "social-composer-lib": "static-1.60338",
  "structured-content-lib": "static-1.25971",
  "theme-previewer-lib": "static-1.53959",
  "tinymce-copilot": "static-1.17228",
  "xray-recommendation-lib": "static-1.8299",
  "automation-ui-routing": "static-1.22015",
  "sql-reporting-client-types": "static-1.5919",
  "attribution-lib": "static-1.42840",
  "reporting-enablement": "static-1.23881",
  "forms-ai-lib": "static-1.4803",
  "codemirror-dlb": "static-1.59532",
  "redux-mock-store": "static-1.8",
  "redux-undo": "static-1.10",
  "seo-tools-lib": "static-1.6778",
  "report-customization-components": "static-1.13961",
  "data-quality-ui-library": "static-1.13899",
  "reporting-filters": "static-1.1049",
  "reporting-insights-lib": "static-1.2636",
  "merge-modal-lib": "static-1.12655",
  "segments-client-types": "static-1.11664"
},
  depPathPrefixes: {
  "marketplace-storefront-public-ui": "/marketplace-storefront-public-ui/static-1.13293",
  "apollo-dlb": "/apollo-dlb/static-3.98",
  "breeze-builder-lib": "/breeze-builder-lib/static-1.852",
  "client-types": "/client-types/static-1.501",
  "data-fetching-client": "/data-fetching-client/static-1.9989",
  "foundations-components": "/foundations-components/static-1.8538",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1563",
  "foundations-theming": "/foundations-theming/static-1.4812",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "graphql": "/graphql/static-1.89",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-test-utils": "/hs-test-utils/static-1.8369",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10670",
  "hubspot-dlb": "/hubspot-dlb/static-2.1905",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4366",
  "HubStyleTokens": "/HubStyleTokens/static-2.11827",
  "I18n": "/I18n/static-7.1679",
  "jasmine-runner": "/jasmine-runner/static-1.6786",
  "marketplace-discovery-studio-lib": "/marketplace-discovery-studio-lib/static-1.686",
  "marketplace-storefront-base": "/marketplace-storefront-base/static-1.13356",
  "quartz": "/quartz/static-1.7502",
  "react-dlb": "/react-dlb/static-1.89",
  "react-rhumb": "/react-rhumb/static-1.17059",
  "reactive-variable-buffer-atom": "/reactive-variable-buffer-atom/static-1.3190",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.10840",
  "reselect": "/reselect/static-3.12",
  "settings-ui-lib": "/settings-ui-lib/static-1.12860",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.183",
  "signup-ui-core": "/signup-ui-core/static-1.10391",
  "source-map": "/source-map/static-1.4",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.7669",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11482",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9868",
  "unified-auth": "/unified-auth/static-1.973",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.1255",
  "usage-tracker": "/usage-tracker/static-1.7649",
  "usage-tracker-core": "/usage-tracker-core/static-1.7499",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8434",
  "hub-http": "/hub-http/static-1.6548",
  "integrations-lib": "/integrations-lib/static-1.17118",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.20793",
  "marketplace-ui-install": "/marketplace-ui-install/static-1.779",
  "property-management-iframe": "/property-management-iframe/static-1.14190",
  "quartz-config": "/quartz-config/static-1.1280",
  "quartz-core": "/quartz-core/static-1.6721",
  "quartz-routing": "/quartz-routing/static-1.932",
  "quick-fetch": "/quick-fetch/static-1.4151",
  "react": "/react/static-7.196",
  "rpc-client-utils": "/rpc-client-utils/static-1.5002",
  "ts-schema": "/ts-schema/static-1.4317",
  "ui-universal-auth": "/ui-universal-auth/static-1.9459",
  "UIComponents": "/UIComponents/static-3.8773",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.94",
  "enviro": "/enviro/static-4.455",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "raven": "/raven/static-3.5925",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "immutable": "/immutable/static-2.87",
  "metrics-js": "/metrics-js/static-1.9963",
  "react-redux": "/react-redux/static-7.79",
  "redux": "/redux/static-4.80",
  "styled-components": "/styled-components/static-2.99",
  "moment": "/moment/static-3.75",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3779",
  "quartz-webpack": "/quartz-webpack/static-1.3726",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.580",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9782",
  "codemirror": "/codemirror/static-5.102",
  "foundations-assets": "/foundations-assets/static-1.5222",
  "pulse": "/pulse/static-1.965",
  "react-codemirror": "/react-codemirror/static-1.10979",
  "ui-extensions-preview-lib": "/ui-extensions-preview-lib/static-1.667",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4807",
  "floating-ui": "/floating-ui/static-1.63",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2528",
  "framer-motion": "/framer-motion/static-1.79",
  "hs-story-utils": "/hs-story-utils/static-1.9761",
  "react-aria": "/react-aria/static-1.72",
  "react-create-root-preference": "/react-create-root-preference/static-1.78",
  "react-select-plus": "/react-select-plus/static-1.113",
  "react-utils": "/react-utils/static-2.5579",
  "react-virtualized": "/react-virtualized/static-2.107",
  "StyleGuideUI": "/StyleGuideUI/static-3.507",
  "tanstack-table": "/tanstack-table/static-1.61",
  "trellis-assets": "/trellis-assets/static-1.2730",
  "ui-fonts": "/ui-fonts/static-1.1089",
  "ui-images": "/ui-images/static-2.1261",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3295",
  "foundations-theming-base": "/foundations-theming-base/static-1.3797",
  "stylex": "/stylex/static-1.41",
  "HeadJS": "/HeadJS/static-2.803",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3480",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.158",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.230",
  "moment-timezone": "/moment-timezone/static-5.91",
  "jasmine": "/jasmine/static-4.4648",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.9038",
  "ai-rendering-library": "/ai-rendering-library/static-1.11154",
  "chirp-fetch": "/chirp-fetch/static-1.2232",
  "connections-embed-lib": "/connections-embed-lib/static-1.1557",
  "copilot-toolkit": "/copilot-toolkit/static-1.11898",
  "feedback-loader": "/feedback-loader/static-1.29852",
  "laboratory-lib": "/laboratory-lib/static-3.7489",
  "marketplace-embed": "/marketplace-embed/static-1.22972",
  "marketplace-ui-details": "/marketplace-ui-details/static-1.10688",
  "marketplace-ui-reviews": "/marketplace-ui-reviews/static-1.20748",
  "marketplace-ui-tracking": "/marketplace-ui-tracking/static-1.14963",
  "sanitize-text": "/sanitize-text/static-1.8493",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.6063",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5335",
  "wootric-nps": "/wootric-nps/static-1.7224",
  "quartz-head": "/quartz-head/static-1.1167",
  "web-vitals": "/web-vitals/static-1.15",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4993",
  "immer": "/immer/static-1.101",
  "immerable": "/immerable/static-1.4482",
  "highcharts": "/highcharts/static-8.111",
  "hs-lodash": "/hs-lodash/static-4.45",
  "reporting-client-types": "/reporting-client-types/static-1.2714",
  "reporting-data": "/reporting-data/static-1.68907",
  "cssUtils": "/cssUtils/static-1.958",
  "flux-actions": "/flux-actions/static-1.373",
  "react-colorpicker": "/react-colorpicker/static-2.10549",
  "react-dnd-compat": "/react-dnd-compat/static-1.4952",
  "redux-observable": "/redux-observable/static-1.75",
  "ReduxMessenger": "/ReduxMessenger/static-2.10706",
  "rxjs": "/rxjs/static-5.10",
  "underscore": "/underscore/static-1.8",
  "usage-tracker-container": "/usage-tracker-container/static-1.7639",
  "icons": "/icons/static-2.693",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.19325",
  "storybook-react": "/storybook-react/static-1.40",
  "trellis-story-utils": "/trellis-story-utils/static-1.4843",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.6021",
  "quartz-i18n": "/quartz-i18n/static-1.1177",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "adobe-sign-auth-lib": "/adobe-sign-auth-lib/static-1.522",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.1495",
  "custom-vendor-connection-lib": "/custom-vendor-connection-lib/static-1.23",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.1086",
  "microsoft-drive-auth-lib": "/microsoft-drive-auth-lib/static-1.202",
  "surveymonkey-integration-lib": "/surveymonkey-integration-lib/static-1.541",
  "slack-ui-library": "/slack-ui-library/static-1.10735",
  "fsm": "/fsm/static-1.4088",
  "customer-data-objects": "/customer-data-objects/static-1.8033",
  "property-translator": "/property-translator/static-1.5730",
  "hs-locale-management": "/hs-locale-management/static-1.318",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8254",
  "hs-promise-utils": "/hs-promise-utils/static-1.5926",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5213",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14533",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5944",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.8113",
  "sanitize": "/sanitize/static-1.4808",
  "superstore": "/superstore/static-1.5095",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10605",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.8385",
  "hub-http-janus": "/hub-http-janus/static-1.887",
  "hubspotter-http": "/hubspotter-http/static-1.4887",
  "immutable-less": "/immutable-less/static-1.4987",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.18200",
  "nav-meta": "/nav-meta/static-1.30528",
  "react-window": "/react-window/static-1.13",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18423",
  "ui-product-approvals-common": "/ui-product-approvals-common/static-1.1151",
  "ai-studio-lib": "/ai-studio-lib/static-1.12486",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.19036",
  "integrations-reconnect-lib": "/integrations-reconnect-lib/static-1.530",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9413",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.8363",
  "ui-product-approvals": "/ui-product-approvals/static-1.29256",
  "ui-tool-access": "/ui-tool-access/static-1.10491",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.4071",
  "property-management-common": "/property-management-common/static-1.6478",
  "opentelemetry-fe-types": "/opentelemetry-fe-types/static-1.112",
  "dispatcher": "/dispatcher/static-1.143",
  "general-store": "/general-store/static-6.20",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.583",
  "module-federation": "/module-federation/static-1.33",
  "opentelemetry-fe": "/opentelemetry-fe/static-1.487",
  "quartz-auth": "/quartz-auth/static-1.1177",
  "quartz-test": "/quartz-test/static-1.1177",
  "quartz-tracking": "/quartz-tracking/static-1.881",
  "trellis-components": "/trellis-components/static-1.2749",
  "csstype": "/csstype/static-1.50",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.412",
  "HubStyle": "/HubStyle/static-2.12134",
  "bender-build-tools": "/bender-build-tools/static-1.3452",
  "autolinker": "/autolinker/static-3.11",
  "chatspot-core": "/chatspot-core/static-1.23183",
  "ContentUtils": "/ContentUtils/static-1.69187",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13367",
  "sassPrefix": "/sassPrefix/static-1.225",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.468",
  "batch-promise": "/batch-promise/static-1.1881",
  "event-emitter": "/event-emitter/static-1.1291",
  "fast-json-patch": "/fast-json-patch/static-1.70",
  "browser-eslint": "/browser-eslint/static-2.57",
  "magpie-lib": "/magpie-lib/static-1.5782",
  "magpie-types": "/magpie-types/static-1.5242",
  "stylex-utils": "/stylex-utils/static-1.147",
  "trellis-theming": "/trellis-theming/static-1.1309",
  "avatar-components": "/avatar-components/static-1.2818",
  "breeze-engine-core": "/breeze-engine-core/static-1.1098",
  "breeze-onboarding-components": "/breeze-onboarding-components/static-1.793",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.41008",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13515",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.15608",
  "ExportDialog": "/ExportDialog/static-6.10714",
  "global-styles-ai-lib": "/global-styles-ai-lib/static-1.199",
  "highlight.js": "/highlight.js/static-1.86",
  "marketplace-embed-ba": "/marketplace-embed-ba/static-1.675",
  "markdown-it": "/markdown-it/static-1.6",
  "mermaid": "/mermaid/static-1.3",
  "reporting-action-components": "/reporting-action-components/static-1.42120",
  "reporting-snowflake": "/reporting-snowflake/static-1.57524",
  "reporting-ui-components": "/reporting-ui-components/static-2.66177",
  "reporting-visualizations": "/reporting-visualizations/static-1.60982",
  "trial-components-library": "/trial-components-library/static-1.14158",
  "ui-addon-teams": "/ui-addon-teams/static-1.21945",
  "upgrade-components-lib": "/upgrade-components-lib/static-1.558",
  "navigation-components": "/navigation-components/static-1.18891",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.1820",
  "simple-logging-lib": "/simple-logging-lib/static-1.3387",
  "fail-safe": "/fail-safe/static-1.290",
  "app-governance-lib": "/app-governance-lib/static-1.2444",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10874",
  "purchase-motions-components": "/purchase-motions-components/static-1.6407",
  "transmute": "/transmute/static-2.97",
  "usage-based-billing-components-lib": "/usage-based-billing-components-lib/static-1.10356",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.6066",
  "usage-tracker-public": "/usage-tracker-public/static-1.7460",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3718",
  "persist-promise": "/persist-promise/static-1.4038",
  "reference-resolvers": "/reference-resolvers/static-1.8517",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.4253",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.672",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3344",
  "final-form": "/final-form/static-1.78",
  "redux-toolkit": "/redux-toolkit/static-1.78",
  "simple-data-table": "/simple-data-table/static-1.3571",
  "merchandise-lib": "/merchandise-lib/static-1.279",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.5092",
  "content-assistance-lib": "/content-assistance-lib/static-1.8240",
  "content-media-capture": "/content-media-capture/static-1.5505",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10167",
  "emoji-mart": "/emoji-mart/static-3.4",
  "file-manager-components": "/file-manager-components/static-1.24574",
  "growth-payments-core": "/growth-payments-core/static-1.26245",
  "knowledge-content-types": "/knowledge-content-types/static-1.8681",
  "PatternValidationJS": "/PatternValidationJS/static-1.3228",
  "payment-link-components": "/payment-link-components/static-1.24211",
  "prosemirror": "/prosemirror/static-1.13",
  "rich-text-lib": "/rich-text-lib/static-1.20348",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10220",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9427",
  "video-components-external": "/video-components-external/static-1.12201",
  "video-data-lib": "/video-data-lib/static-1.35859",
  "navigation-messaging": "/navigation-messaging/static-1.8218",
  "collaboration-sidebar": "/collaboration-sidebar/static-1.58783",
  "crm-component-utils": "/crm-component-utils/static-1.39900",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.6226",
  "customer-data-properties": "/customer-data-properties/static-1.52678",
  "external-options-client-types": "/external-options-client-types/static-1.4364",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7229",
  "property-value-citations": "/property-value-citations/static-1.3292",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8440",
  "opentelemetry-web": "/opentelemetry-web/static-1.15",
  "beacon-keepalive-queue": "/beacon-keepalive-queue/static-1.40",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10668",
  "base-ui": "/base-ui/static-1.22",
  "react-day-picker": "/react-day-picker/static-1.10",
  "tanstack-virtual": "/tanstack-virtual/static-1.38",
  "cms-field-types": "/cms-field-types/static-1.5148",
  "content-icons-ui": "/content-icons-ui/static-1.2399",
  "atom": "/atom/static-1.5418",
  "idb-keyval": "/idb-keyval/static-1.51",
  "reactive-lib": "/reactive-lib/static-1.1055",
  "breeze-artifacts-sdk": "/breeze-artifacts-sdk/static-1.444",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.19303",
  "onboarding-journeys-lib": "/onboarding-journeys-lib/static-1.996",
  "onboarding-scopes": "/onboarding-scopes/static-1.6789",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7583",
  "crm-message-bus": "/crm-message-bus/static-1.43826",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.23443",
  "events-data-lib": "/events-data-lib/static-1.584",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.5062",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4245",
  "hs-resources": "/hs-resources/static-1.528",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.1343",
  "onboarding-tours": "/onboarding-tours/static-1.17172",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.14520",
  "academy-common-lib": "/academy-common-lib/static-1.15068",
  "dashboard-lib": "/dashboard-lib/static-1.82934",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.19028",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.9044",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.11434",
  "user-context": "/user-context/static-1.5457",
  "reporting-plugins": "/reporting-plugins/static-1.10796",
  "reporting-reports": "/reporting-reports/static-1.68584",
  "hubs-service-types": "/hubs-service-types/static-1.1596",
  "purchase-motions-api": "/purchase-motions-api/static-1.6410",
  "salesImages": "/salesImages/static-1.596",
  "signup-constants": "/signup-constants/static-1.19680",
  "nest": "/nest/static-1.573",
  "breeze-engine-chat-components": "/breeze-engine-chat-components/static-1.798",
  "ably": "/ably/static-2.2",
  "bend-plugin-fail-safe": "/bend-plugin-fail-safe/static-1.241",
  "framework-listing-lib": "/framework-listing-lib/static-2.29557",
  "fuzzy": "/fuzzy/static-1.8",
  "user-configuration-lib": "/user-configuration-lib/static-1.31501",
  "apps-service-types": "/apps-service-types/static-1.4067",
  "oauth-service-types": "/oauth-service-types/static-1.4569",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8396",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.5387",
  "one-click-checkout": "/one-click-checkout/static-1.473",
  "platform-infra-nav-components": "/platform-infra-nav-components/static-1.7917",
  "subscription-experience-data-types": "/subscription-experience-data-types/static-1.15271",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3796",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.10159",
  "redux-thunk": "/redux-thunk/static-2.80",
  "react-flip-move": "/react-flip-move/static-1.78",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.29364",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.13309",
  "fix-webm-duration": "/fix-webm-duration/static-1.30",
  "notification-sounds": "/notification-sounds/static-1.4761",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "seat-types-lib": "/seat-types-lib/static-1.795",
  "ui-addon-opt": "/ui-addon-opt/static-4.8702",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.6664",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5416",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3864",
  "data-token-picker": "/data-token-picker/static-1.16928",
  "FileManagerLib": "/FileManagerLib/static-1.40214",
  "content-media-compositions": "/content-media-compositions/static-2.17316",
  "media-bridge-lib": "/media-bridge-lib/static-1.19447",
  "chatspot-widget-iframe": "/chatspot-widget-iframe/static-1.23174",
  "collaboration-sidebar-common": "/collaboration-sidebar-common/static-1.3580",
  "marketing-platform-lib": "/marketing-platform-lib/static-1.7209",
  "card-properties-lib": "/card-properties-lib/static-1.45071",
  "commerce-subscription-lib": "/commerce-subscription-lib/static-1.37843",
  "crm-actions": "/crm-actions/static-1.6684",
  "crm-cards-sdk": "/crm-cards-sdk/static-1.44659",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9997",
  "customer-data-tracking": "/customer-data-tracking/static-1.7218",
  "calling-global-api": "/calling-global-api/static-1.65717",
  "calling-internal-common": "/calling-internal-common/static-1.31658",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.67099",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.59393",
  "commerce-products-lib": "/commerce-products-lib/static-1.10603",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.4040",
  "crm-index-visualization-core": "/crm-index-visualization-core/static-1.4583",
  "crm-links": "/crm-links/static-1.6658",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4371",
  "formula-editor": "/formula-editor/static-1.14812",
  "google-libphonenumber": "/google-libphonenumber/static-1.45",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4452",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.971",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3931",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.49750",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.4206",
  "smart-data-capture-core": "/smart-data-capture-core/static-1.192",
  "smart-property-lib": "/smart-property-lib/static-1.8360",
  "tiered-pricing": "/tiered-pricing/static-1.2006",
  "topics-actions-lib": "/topics-actions-lib/static-1.504",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11320",
  "zustand": "/zustand/static-1.85",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.348",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.7134",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.1734",
  "growth-data-modal": "/growth-data-modal/static-1.5935",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3401",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2745",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.1239",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7986",
  "academy-service-client": "/academy-service-client/static-1.4028",
  "croppie": "/croppie/static-2.10",
  "FileManagerCore": "/FileManagerCore/static-1.40073",
  "SafeStorage": "/SafeStorage/static-1.4742",
  "video-embed": "/video-embed/static-1.36693",
  "redux-actions": "/redux-actions/static-3.70",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.25049",
  "viral-links-lib": "/viral-links-lib/static-1.7412",
  "nested-table": "/nested-table/static-1.571",
  "timezone-utils": "/timezone-utils/static-2.5579",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.18421",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.10371",
  "campaigns-utils-lib": "/campaigns-utils-lib/static-1.3558",
  "ui-addon-calendars": "/ui-addon-calendars/static-2.5677",
  "customer-data-views-management": "/customer-data-views-management/static-1.26082",
  "framework-data-table": "/framework-data-table/static-2.12604",
  "nudge-client-utils": "/nudge-client-utils/static-1.3190",
  "nudge-custom-ui-functions": "/nudge-custom-ui-functions/static-1.1536",
  "switchboard-lib": "/switchboard-lib/static-1.556",
  "access-check-ui-lib": "/access-check-ui-lib/static-1.1645",
  "app-users-service-client": "/app-users-service-client/static-1.5956",
  "app-users-service-types": "/app-users-service-types/static-1.5364",
  "mini-checkout-client": "/mini-checkout-client/static-1.27568",
  "onboarding-utils": "/onboarding-utils/static-1.5707",
  "permissions-shared-i18n-strings-fe": "/permissions-shared-i18n-strings-fe/static-1.2123",
  "ui-coaching-tips-shared-config": "/ui-coaching-tips-shared-config/static-1.29349",
  "checkout-sdk": "/checkout-sdk/static-3.24411",
  "payment-method-components": "/payment-method-components/static-1.7183",
  "touchless-buying-components": "/touchless-buying-components/static-1.6279",
  "upgrade-catalog-service-types": "/upgrade-catalog-service-types/static-1.3796",
  "edison-service-client-types": "/edison-service-client-types/static-1.730",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6921",
  "audio-components": "/audio-components/static-1.6387",
  "FileManagerImages": "/FileManagerImages/static-1.37725",
  "video-components": "/video-components/static-1.14203",
  "js-cookie": "/js-cookie/static-1.18",
  "crm_data": "/crm_data/static-4.92904",
  "customer-data-sidebar": "/customer-data-sidebar/static-2.46789",
  "enrichment-lib": "/enrichment-lib/static-1.515",
  "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.4599",
  "universal-record-utils-lib": "/universal-record-utils-lib/static-1.2052",
  "commerce-billing-lib": "/commerce-billing-lib/static-1.20263",
  "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.19294",
  "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.11100",
  "crm-fe-perf": "/crm-fe-perf/static-1.23234",
  "calling-error-reporting": "/calling-error-reporting/static-1.31665",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11377",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6872",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.2124",
  "commerce-permissions": "/commerce-permissions/static-1.1113",
  "products-iframe-lib": "/products-iframe-lib/static-1.8640",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.11052",
  "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6780",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10753",
  "sales-views-client-types": "/sales-views-client-types/static-1.4592",
  "bark-lib": "/bark-lib/static-1.16850",
  "browser-prettier": "/browser-prettier/static-1.11",
  "data-agent-kit": "/data-agent-kit/static-1.694",
  "policy-lib": "/policy-lib/static-1.7140",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10816",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2558",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.2773",
  "user-context-client": "/user-context-client/static-1.4844",
  "cropperjs": "/cropperjs/static-1.10",
  "html-to-image": "/html-to-image/static-1.61",
  "urlinator": "/urlinator/static-1.4866",
  "outpost": "/outpost/static-1.4489",
  "draft-convert": "/draft-convert/static-2.80",
  "draft-extend": "/draft-extend/static-3.83",
  "draft-js": "/draft-js/static-5.85",
  "draft-plugins": "/draft-plugins/static-2.22200",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.4183",
  "ts-utils-lib": "/ts-utils-lib/static-1.484",
  "copilot-messaging": "/copilot-messaging/static-1.2148",
  "crm-export-dialog": "/crm-export-dialog/static-1.6619",
  "crm-index-ui-shimmer": "/crm-index-ui-shimmer/static-1.2726",
  "crm-view-components": "/crm-view-components/static-1.1246",
  "react-beautiful-dnd": "/react-beautiful-dnd/static-1.70",
  "customer-data-associations": "/customer-data-associations/static-1.7666",
  "tasks-actions-lib": "/tasks-actions-lib/static-1.193",
  "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.2947",
  "nudge-renderer-utils": "/nudge-renderer-utils/static-1.3266",
  "whisper-core-api": "/whisper-core-api/static-1.7385",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15611",
  "emoji-regex": "/emoji-regex/static-1.7",
  "settings-content-modals": "/settings-content-modals/static-1.46901",
  "hub-http-rxjs": "/hub-http-rxjs/static-1.854",
  "normalizr": "/normalizr/static-3.9",
  "ramda": "/ramda/static-1.7",
  "billing-payments-client-types": "/billing-payments-client-types/static-1.4328",
  "company-details-components": "/company-details-components/static-1.6543",
  "react-performance-metrics-lib": "/react-performance-metrics-lib/static-1.889",
  "pricing-pages-ui-components": "/pricing-pages-ui-components/static-1.15955",
  "quote-checkout-service-types": "/quote-checkout-service-types/static-1.3788",
  "social-insights-client-types": "/social-insights-client-types/static-1.22706",
  "crm_universal": "/crm_universal/static-1.22534",
  "customer-data-email": "/customer-data-email/static-1.18562",
  "card-payment-highlight-lib": "/card-payment-highlight-lib/static-1.38051",
  "commerce-contract-lib": "/commerce-contract-lib/static-1.13424",
  "invoices-highlight-card-lib": "/invoices-highlight-card-lib/static-1.55829",
  "orders-highlight-card-lib": "/orders-highlight-card-lib/static-1.22248",
  "products-highlight-card-lib": "/products-highlight-card-lib/static-1.18886",
  "quotes-highlight-card-lib": "/quotes-highlight-card-lib/static-1.72850",
  "crm-source-interpretation-lib": "/crm-source-interpretation-lib/static-1.5667",
  "data-agent-utils": "/data-agent-utils/static-1.577",
  "crm-object-search-query-utilities": "/crm-object-search-query-utilities/static-1.10243",
  "utility-belt": "/utility-belt/static-1.2869",
  "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.23899",
  "stripe-embedded-components": "/stripe-embedded-components/static-1.8036",
  "customer-data-rte": "/customer-data-rte/static-1.33695",
  "cv-backend-services": "/cv-backend-services/static-1.1597",
  "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.6323",
  "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.5440",
  "qrcode-generator": "/qrcode-generator/static-1.76",
  "quotes-client-types": "/quotes-client-types/static-1.38940",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.36901",
  "react-reducer-toolkit": "/react-reducer-toolkit/static-1.16419",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.7947",
  "hub-http-contrib": "/hub-http-contrib/static-1.3376",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5550",
  "access-control-lib": "/access-control-lib/static-1.10773",
  "EmailComponents": "/EmailComponents/static-1.55605",
  "EmailData": "/EmailData/static-1.54283",
  "redux-less": "/redux-less/static-2.9811",
  "company-details-service-types": "/company-details-service-types/static-1.4279",
  "segments-query-core": "/segments-query-core/static-1.1760",
  "pricing-pages-api": "/pricing-pages-api/static-1.15820",
  "sequences-lib": "/sequences-lib/static-1.8573",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10632",
  "products-ui-components": "/products-ui-components/static-1.41121",
  "accounting-integrations-ui-components": "/accounting-integrations-ui-components/static-1.7579",
  "invoices-ui-lib": "/invoices-ui-lib/static-1.55845",
  "commerce-products-api": "/commerce-products-api/static-1.2727",
  "invoices-iframe-lib": "/invoices-iframe-lib/static-1.57903",
  "quotes-modal-lib": "/quotes-modal-lib/static-1.103528",
  "quotes-ui-lib": "/quotes-ui-lib/static-1.81571",
  "stripe-connect-js": "/stripe-connect-js/static-1.78",
  "draft-content-plugins": "/draft-content-plugins/static-1.28954",
  "ContentComponents": "/ContentComponents/static-2.72143",
  "ContentData": "/ContentData/static-1.69262",
  "marketing-email-service-types": "/marketing-email-service-types/static-1.2115",
  "messaging-editing-lib": "/messaging-editing-lib/static-1.47205",
  "messaging-usage-based-billing-components-lib": "/messaging-usage-based-billing-components-lib/static-1.2067",
  "automation-ui-source-apps": "/automation-ui-source-apps/static-1.19740",
  "automation-ui-types": "/automation-ui-types/static-1.20658",
  "messaging-types-lib": "/messaging-types-lib/static-1.46942",
  "onboarding-settings-client": "/onboarding-settings-client/static-1.4845",
  "sequences-client-types-lib": "/sequences-client-types-lib/static-1.8430",
  "commerce-tax-lib": "/commerce-tax-lib/static-1.876",
  "price-books-api": "/price-books-api/static-1.1784",
  "price-books-components": "/price-books-components/static-1.1842",
  "property-description-translator": "/property-description-translator/static-1.4173",
  "ramp-editor": "/ramp-editor/static-1.940",
  "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.3852",
  "totals-ui-components": "/totals-ui-components/static-1.24343",
  "SalesContentIndexUI": "/SalesContentIndexUI/static-3.9660",
  "advanced-menus-core": "/advanced-menus-core/static-1.15620",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12492",
  "automation-ui-ubb": "/automation-ui-ubb/static-1.6574",
  "blueimp-md5": "/blueimp-md5/static-1.8",
  "content-embed-lib": "/content-embed-lib/static-1.7673",
  "data-token-views": "/data-token-views/static-1.16909",
  "forms-utils-lib": "/forms-utils-lib/static-1.13133",
  "payments-embed-points-lib": "/payments-embed-points-lib/static-1.13636",
  "react-tinymce": "/react-tinymce/static-1.56034",
  "simple-menus-core": "/simple-menus-core/static-1.15619",
  "simple-menus-lib": "/simple-menus-lib/static-1.17136",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-config": "/tinymce-config/static-2.55160",
  "tinymce-data": "/tinymce-data/static-1.41245",
  "tinymce-plugins": "/tinymce-plugins/static-1.58274",
  "tinymce-themes": "/tinymce-themes/static-1.57130",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.16603",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34898",
  "videoconference-integration-components": "/videoconference-integration-components/static-1.7326",
  "automation-applications-service-types": "/automation-applications-service-types/static-1.3658",
  "automation-platform-service-types": "/automation-platform-service-types/static-1.2669",
  "ContentEditorUI": "/ContentEditorUI/static-2.77973",
  "content-whatsapp-service-types": "/content-whatsapp-service-types/static-1.578",
  "short-messages-app-service-client": "/short-messages-app-service-client/static-1.4254",
  "web-interactives-components": "/web-interactives-components/static-1.14290",
  "web-interactives-data": "/web-interactives-data/static-1.14291",
  "messaging-shared-utils-lib": "/messaging-shared-utils-lib/static-1.1516",
  "messaging-user-info-utils-lib": "/messaging-user-info-utils-lib/static-1.1686",
  "email-portal-health-service-types": "/email-portal-health-service-types/static-1.1318",
  "line-items-api": "/line-items-api/static-1.1135",
  "commerce-totals-service-types": "/commerce-totals-service-types/static-1.4056",
  "FireAlarmUi": "/FireAlarmUi/static-1.4748",
  "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.4408",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "automation-ui-core": "/automation-ui-core/static-2.22594",
  "automation-ui-usage-tracking": "/automation-ui-usage-tracking/static-1.22057",
  "data-studio-ubb": "/data-studio-ubb/static-1.3564",
  "interframe": "/interframe/static-3.5091",
  "layout-dnd-components": "/layout-dnd-components/static-1.13015",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11990",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9289",
  "campaigns-lib": "/campaigns-lib/static-1.27709",
  "content-management-data-lib": "/content-management-data-lib/static-1.6006",
  "copilot-plugins": "/copilot-plugins/static-1.11870",
  "cta-picker": "/cta-picker/static-1.37134",
  "customer-agent-discovery-components-lib": "/customer-agent-discovery-components-lib/static-1.4012",
  "editor-components": "/editor-components/static-1.13691",
  "editor-iframe-lib": "/editor-iframe-lib/static-1.8839",
  "error-messaging-js": "/error-messaging-js/static-1.5535",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.86635",
  "layout-data-lib": "/layout-data-lib/static-1.10315",
  "pictos": "/pictos/static-7.191",
  "react-transition-group": "/react-transition-group/static-2.73",
  "redux-request-state": "/redux-request-state/static-1.10983",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.2078",
  "smart-content-core": "/smart-content-core/static-1.43228",
  "smart-content-lib": "/smart-content-lib/static-1.43881",
  "social-composer-lib": "/social-composer-lib/static-1.60338",
  "structured-content-lib": "/structured-content-lib/static-1.25971",
  "theme-previewer-lib": "/theme-previewer-lib/static-1.53959",
  "tinymce-copilot": "/tinymce-copilot/static-1.17228",
  "xray-recommendation-lib": "/xray-recommendation-lib/static-1.8299",
  "automation-ui-routing": "/automation-ui-routing/static-1.22015",
  "sql-reporting-client-types": "/sql-reporting-client-types/static-1.5919",
  "attribution-lib": "/attribution-lib/static-1.42840",
  "reporting-enablement": "/reporting-enablement/static-1.23881",
  "forms-ai-lib": "/forms-ai-lib/static-1.4803",
  "codemirror-dlb": "/codemirror-dlb/static-1.59532",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-undo": "/redux-undo/static-1.10",
  "seo-tools-lib": "/seo-tools-lib/static-1.6778",
  "report-customization-components": "/report-customization-components/static-1.13961",
  "data-quality-ui-library": "/data-quality-ui-library/static-1.13899",
  "reporting-filters": "/reporting-filters/static-1.1049",
  "reporting-insights-lib": "/reporting-insights-lib/static-1.2636",
  "merge-modal-lib": "/merge-modal-lib/static-1.12655",
  "segments-client-types": "/segments-client-types/static-1.11664"
}
};
